<template>
  <component
    :is="vnodeToRender"
    v-if="vnodeToRender"
    :show="show"
    :unmuted="unmuted"
    :preload-next-slot-now="preloadNextSlotNow"
    :seamless-incoming-from-link="seamlessIncomingFromLink"
    :continuous-media-offset-seconds="continuousMediaOffsetSeconds"
    :presentation-hold-overlay="presentationHoldOverlay"
    :fit="sectionFit"
  />
</template>

<script lang="ts" setup>
import type { TSectionFit } from '@lucimark/shared/helpers/sectionMediaFit'
import type { TFacet } from '@lucimark/shared/models/playlist'
import type { VNode } from 'vue'
/** Renders a native facet VNode from the asset index (e.g. HLS, video, image). */
import type { IAssetEntry } from '@/types'
import { shallowRef, watch } from 'vue'

const props = withDefaults(
  defineProps<{
    assetEntry: IAssetEntry
    facet: TFacet & { asset: string }
    bufferIndex: number
    show: boolean
    unmuted: boolean
    preloadNextSlotNow: boolean
    /** Passed to {@link VideoContainer} when facet is video/HLS. */
    seamlessIncomingFromLink?: boolean
    continuousMediaOffsetSeconds?: number
    /** Sticky outgoing overlay: paint only, do not play (Phase B). */
    presentationHoldOverlay?: boolean
    /** Zone fit from the frame section. Image/video containers apply their own default when omitted. */
    sectionFit?: TSectionFit
  }>(),
  { seamlessIncomingFromLink: false, continuousMediaOffsetSeconds: 0, presentationHoldOverlay: false }
)

const vnodeToRender = shallowRef<VNode | null>(null)

watch(
  () => {
    const entry = props.assetEntry
    const base = 'vnode' in entry && entry.vnode ? entry.vnode : null
    return { base }
  },
  ({ base }) => {
    vnodeToRender.value = base
  },
  { immediate: true }
)
</script>
